import { useState } from "react";
import { GenericInfoField } from "../../../../common/components/ui/GenericInfoField";
import { brDateHourFormat } from "../../../../common/helpers/date.helpers";
import { useIndicatorDashboardContext } from "./useIndicatorDashboardContext";
import {
  indicatorDataBankInfo,
  personalIndicatorInfo,
} from "./indicator-edit-constants";
import { FaRegCopy, FaShare } from "react-icons/fa";
import { Button } from "@/components/ui/button";
import { ModalViewLogs } from "@/modules/logsDetails/logsDetails.modal";

function IndicatorInfo() {
  const { indicator } = useIndicatorDashboardContext();
  const setIndicatorInfo = personalIndicatorInfo(indicator);
  const setIndicatorDataBankInfo = indicatorDataBankInfo(indicator);
  const [copied, setCopied] = useState(false);
  const link = `https://embaixador.locavibe.com.br/embaixador/${indicator?.code}`;
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(link).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    });
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Acesse esse link para alugar uma moto",
          url: link,
        });
      } catch (error) {
        console.error("Erro ao compartilhar:", error);
      }
    } else {
      alert("A API de Compartilhamento não é suportada neste navegador.");
    }
  };

  return (
    <>
      <div className="tabs-border-line">
        <section className="tabs-item-style">
          <h2 className="text-2xl font-semibold my-4">
            Informações do Indicador
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 grid-rows-2 mb-4 gap-2">
            {setIndicatorInfo.map((info) => {
              return (
                <GenericInfoField
                  key={info.id}
                  id={info.id}
                  spanSize={info.spanSize}
                  label={info.label}
                  value={info.value}
                />
              );
            })}

            {/* <div className="flex items-center justify-between">
            <label className="font-semibold">Habilita abordagem pelo time comercial (SDR)</label>
            <SlideToggle
              name="sdrEnable"
              initialState={indicator.sdrEnable}
              onToggle={(checked) => {
                setSdrEnable(checked);                             
                sdrIndicator({ _id: indicator._id!, sdrEnable: checked });
              }}
            />
          </div> */}
          </div>

          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center p-4 bg-gray-100 rounded-md border">
            <div className="flex flex-col mb-4 sm:mb-0">
              <span className="text-lg sm:text-xl font-semibold">
                Link para compartilhar:
              </span>
              <a
                href="#"
                className="text-blue-600 underline break-all"
                onClick={handleCopy}
              >
                https://embaixador.locavibe.com.br/embaixador/{indicator?.code}
              </a>
            </div>
            <div className="flex items-center space-x-4">
              <button onClick={handleCopy} className="relative bg-transparent">
                {copied && (
                  <div className="absolute bg-white border w-auto ml-4 px-3 py-2 bg-green-500 text-greenPrimary text-sm rounded shadow-lg z-50">
                    Link copiado!
                  </div>
                )}
                <FaRegCopy className="text-gray-600 h-6 w-6" />
              </button>
              <button onClick={handleShare} className="bg-transparent">
                <FaShare className="text-gray-600 h-6 w-6" />
              </button>
            </div>
          </div>
        </section>

        <div className="div-tabs-border-line"></div>

        <section className="tabs-item-style">
          <h2 className="text-2xl font-semibold my-4">Informações bancárias</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 grid-rows-3 gap-2">
            {setIndicatorDataBankInfo.map((info) => {
              return (
                <GenericInfoField
                  key={info.id}
                  id={info.id}
                  spanSize={info.spanSize}
                  label={info.label}
                  value={info.value}
                />
              );
            })}
          </div>
        </section>

        <div className="div-tabs-border-line"></div>

        <section className="tabs-item-style">
          <h2 className="ftext-2xl font-semibold my-4">Observações</h2>
          <section>
            {indicator?.observations
              ?.slice()
              .reverse()
              .map((observation, index) => (
                <div
                  key={index}
                  className="w-full bg-gray/10 my-4 p-2 rounded-md border border-gray/40"
                >
                  <label className="font-semibold">
                    {brDateHourFormat(observation.date)}
                  </label>
                  <p className="whitespace-pre-wrap">
                    <h3 className="font-semibold">Observação:</h3>
                    {observation.text}
                  </p>
                  <br />
                  <p className="font-semibold">
                    Criado por: {observation.author}
                  </p>
                </div>
              ))}
          </section>
        </section>
        <div className="div-tabs-border-line"></div>
        <section className="tabs-item-style">
          <div className="max-w-7xl mx-auto ">
            <Button
              variant="destructive"
              className={`bg-redPrimary text-white font-semibold p-2 rounded-md mb-2 sm:mb-0`}
              onClick={() => setIsLogModalOpen(true)}
            >
              Visualizar Logs
            </Button>
          </div>
        </section>
      </div>
      {isLogModalOpen && indicator._id && (
        <ModalViewLogs
          onClose={() => setIsLogModalOpen(false)}
          entity="ambassador" // Entidade fixa como solicitado
          entityId={indicator._id} // ID do veículo do contexto
        />
      )}
    </>
  );
}
export default IndicatorInfo;
